import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import Collapse from '@material-ui/core/Collapse';

import {REGISTRATION_NUMBER_CODE} from 'front-onceforall-core/dist/utils/organisations';
import {isEmpty} from 'front-onceforall-core/dist/utils/strings';
import {Icon} from 'front-onceforall-core';

class OrganisationDetails extends Component {
  render() {
    const {organisation} = this.props;
    const identificationNumbers = organisation.identificationNumbers ? Object.keys(organisation.identificationNumbers).map(code => (
      <div
        key={code}
        data-id={code}
      >
        <span>{<strong><Translate value={`identificationNumber.${organisation.country}.${code}.name`}/></strong>}: {organisation.identificationNumbers[code]}</span>
      </div>
    )) :
      null;

    return (
      <Collapse in={this.props.isExpanded}>
        <div
          style={{padding: '0 45px', margin: '0 -45px'}}
          className="row py-2"
        >
          <div className="col-lg-3">
            <strong><Translate value={`identificationNumber.${organisation.country}.${REGISTRATION_NUMBER_CODE}.name`}/>:</strong>
            <span data-id="registrationNumber"> {organisation.registrationNumber}</span>
            <span data-id="identificationNumber">{identificationNumbers}</span>
            {!isEmpty(organisation.website) &&
              <div className="flex-container active font-size-s">
                <Icon
                  icon="new-tab"
                  size={16}
                />
                <a
                  href={organisation.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-id="website"
                >
                  {organisation.website}
                </a>
              </div>
            }
          </div>
          <div className="col-lg-9">
            <strong><Translate value="address.addressLine"/>:</strong>
            <div data-id="addressLine1">{organisation.address.addressLine}</div>
            <div data-id="addressLine2">
              <span>{organisation.address.postCode} {organisation.address.city} </span>
              <Translate value={`country.${organisation.country}`}/>
            </div>
          </div>
        </div>
      </Collapse>
    );
  }
}

OrganisationDetails.propTypes = {
  organisation: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired
};

export default OrganisationDetails;
